import type { PropsWithChildren } from "react";

import { Box } from "@/ui/layout";
import { ModalLayoutDimensions } from "@/ui/layout/ModalTypes";

export const HeaderDecorator = ({ children }: PropsWithChildren) => {
  return (
    <Box
      height={ModalLayoutDimensions.HeaderHeight}
      left={0}
      position="absolute"
      right={0}
      top={0}
    >
      {children}
    </Box>
  );
};
